<template>
  <div>
    <ul class="page_navigation">
      <li>
        <page-button @click.native="clickPrevPageButtonHandler">＜</page-button>
      </li>
      <li v-for="pageNumber in viewPageNumbers" :key="`page_numbers_${pageNumber}`">
        <page-button :selected=isSelectedNumber(pageNumber) @click.native="clickPageButtonHandler(pageNumber)">{{pageNumber}}</page-button>
      </li>
      <li>
        <page-button @click.native="clickNextPageButtonHandler">＞</page-button>
      </li>
    </ul>
  </div>
</template>

<script>
import PageButton from '@/components/PageButton'
export default {
  name: 'PageNavigation',
  components: {
    PageButton
  },
  props: {
    page_number: {
      type: Number,
      required: true
    },
    max_page_number: {
      type: Number,
      required: true
    }
  },
  computed: {
    viewPageNumbers () {
      let tmpMinNumber = this.page_number - 2
      let tmpMaxNumber = this.page_number + 2

      let underLimitOverCount = 0
      if (tmpMinNumber < 1) {
        underLimitOverCount = 1 - tmpMinNumber
        tmpMinNumber = 1
      }

      let upperLimitOverCount = 0
      if (tmpMaxNumber > this.max_page_number) {
        upperLimitOverCount = tmpMaxNumber - this.max_page_number
        tmpMaxNumber = this.max_page_number
      }

      if (underLimitOverCount > 0) {
        tmpMaxNumber += underLimitOverCount
        if (tmpMaxNumber > this.max_page_number) {
          tmpMaxNumber = this.max_page_number
        }
      }
      if (upperLimitOverCount > 0) {
        tmpMinNumber -= upperLimitOverCount
        if (tmpMinNumber < 1) {
          tmpMinNumber = 1
        }
      }
      const numbers = []
      for (let i = tmpMinNumber; i <= tmpMaxNumber; i++) {
        numbers.push(i)
      }
      return numbers
    }
  },
  methods: {
    /**
     * 選択中番号か判定
     * @param number
     */
    isSelectedNumber (number) {
      return this.page_number === number
    },
    /**
     * ページボタンクリック時のハンドラ
     * @param pageNumber
     */
    clickPageButtonHandler (pageNumber) {
      this.$emit('changePageNumber', {
        pageNumber
      })
    },
    /**
     * ページ後退ボタンクリック時のハンドラ
     */
    clickPrevPageButtonHandler () {
      const pageNumber = Math.max(this.page_number - 1, 1)
      this.clickPageButtonHandler(pageNumber)
    },
    /**
     * ページ進行ボタンクリック時のハンドラ
     */
    clickNextPageButtonHandler () {
      const pageNumber = Math.min(this.page_number + 1, this.max_page_number)
      this.clickPageButtonHandler(pageNumber)
    }
  }
}
</script>

<style scoped>
  ul.page_navigation {
    text-align: center;
    color: #676767;
    padding: 0;
  }

  ul.page_navigation li {
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    border: 1px solid #ec8dae;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    margin: 0 5px;
  }

  ul.page_navigation li:first-child,
  ul.page_navigation li:last-child {
    border: none;
  }
</style>
